import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import QRCode from 'qrcode.react';
import domtoimage from 'dom-to-image-improved';
import {changeDpiDataUrl} from "changedpi/src";
import './QrCodeGenerator.scss';

import qrWhiteBgImage from '../assets/images/white_sensor_bg.jpg';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const QrCodeGeneratorWhite = () => {
    const { t } = useSelector(selector);
    const [scannerCode, setScannerCode] = useState('');
    const [count, setCount] = useState(null);
    const [qrCodeImage, setQrCodeImage] = useState(null);
    const [qrCodeString, setQrCodeString] = useState(null);
    const [qrCodeCount, setQrCodeCount] = useState(null);

    const createQrCode = data => <QRCode id='qrCode' value={data} size={180}/>;

    const generateQrCode = (data, count) => {
        setQrCodeString(data);
        setQrCodeCount(count);
        return createQrCode(data);
    };

    const downloadQR = () => {
//        const node = document.getElementById('qrCodeImageComposition');
        const node = document.getElementById('qrWhiteImageComposition');

        domtoimage.toJpeg(node, {quality: 1})
            .then(dataUrl => {
                const dataUrl300dpi = changeDpiDataUrl(dataUrl, 300);
                let downloadLink = document.createElement('a');
                downloadLink.href = dataUrl300dpi;
                downloadLink.download = document.getElementsByClassName('qrCodeText')[0].innerHTML + "_white.jpg";

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            })
            .catch(function (error) {
                console.error('Oops, something went wrong!', error);
            });
    };

    return (
        <div className='qrCodeGenerator'>
            <div className='qrCodeGeneratorHeader'>{t.gettext('QR Code Generator White')}</div>
            <div className='qrCodeGeneratorBox'>
                <form className='qrCodeGeneratorForm'>
                    <div className='qrCodeGeneratorFormItem'>
                        <div className='qrCodeGeneratorFormLabel'>
                            {t.gettext('Sensor Code')}
                        </div>
                        <input
                            className='qrCodeGeneratorFormInput'
                            type='text'
                            onChange={e => setScannerCode(e.target.value)}
                        />
                    </div>
                    <div className='qrCodeGeneratorFormItem'>
                        <div className='qrCodeGeneratorFormLabel'>
                            {t.gettext('Count')}
                        </div>
                        <input
                            className='qrCodeGeneratorFormInput'
                            type='number'
                            min={0}
                            onChange={e => setCount(e.target.value)}
                        />
                    </div>
                    <div className='generateButtonHolder'>
                        <button
                            className='generateButton'
                            onClick={e => {
                                e.preventDefault();
                                setQrCodeImage(generateQrCode(scannerCode, count));
                            }}
                            disabled={!scannerCode || !count}
                        >
                            {t.gettext('GENERATE')}
                        </button>
                    </div>
                </form>
                {qrCodeImage &&
                    <div
                        id='qrWhiteImageComposition'
                        className='qrWhiteImageComposition'
                        style={{backgroundImage: "url(" + qrWhiteBgImage + ")", backgroundSize: 'cover'}}
                    >
                        <div className='qrCodeImageWrapper'>
                            {qrCodeImage}
                        </div>
                        <div className='qrCodeText'>{qrCodeCount + '-' + qrCodeString}</div>
                    </div>
                }
                {qrCodeImage &&
                    <div className='downloadButtonHolder'>
                        <button
                            className='downloadButton'
                            onClick={downloadQR}
                            disabled={!scannerCode || !count}
                        >
                            {t.gettext('DOWNLOAD')}
                        </button>
                    </div>
                }
            </div>
        </div>
    );
};

export default QrCodeGeneratorWhite;
